import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
@Component({
  selector: 'app-beta-view',
  templateUrl: './beta-view.component.html',
  styleUrls: ['./beta-view.component.scss']
})
export class BetaViewComponent extends BaseComponent implements OnInit {

  constructor(
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit(): void {
  }


}
